import script from "./WorklistPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorklistPage.vue?vue&type=script&setup=true&lang=ts"

import "./WorklistPage.vue?vue&type=style&index=0&id=03093d32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03093d32"]])

export default __exports__